import React from 'react'
import HeaderImage from '../assets/Executive Management.jpeg'
import Board from '../assets/boardmembers.jpg';
import OurPeople from '../assets/leadership.jpg';
import Navigation from '../navbar'
import CEO from '../assets/leadership/ceo.png'
import Jomo from '../assets/leadership/stephen.png'
import Bempah from '../assets/leadership/owusu-bempah.png'
import Sylvia from '../assets/leadership/sylvia.png'
import Natasha from '../assets/leadership/natasha.png'
import Rene from '../assets/leadership/rene.png'
import Asmah from '../assets/leadership/asmah.png'
import Jeremiah from '../assets/leadership/jeremiah.png'
import Augustina from '../assets/leadership/augustina.png'
import RobertLartey from '../assets/leadership/robert.png'
import NanaYaa from '../assets/leadership/nana-yaa.png'
import Ben from '../assets/leadership/benjamin.png'
import Albert from '../assets/leadership/albert.png'
import Alma from '../assets/leadership/alma.png'
import George from '../assets/leadership/george.png'
import Footer from '../footer'
import JudithBlay from '../assets/leadership/judith.png'
import Charlotte from '../assets/leadership/charlotte.png'
import Sampson from '../assets/leadership/sampson.png'
import Maxwell from '../assets/leadership/maxwell.png'
import Moses from '../assets/leadership/emmanuel.png'
import Issaka from '../assets/leadership/abduljamil.png'
import Yvonne from '../assets/leadership/yvonne.png'

import { useNavigate } from 'react-router-dom';


function Leadership() {
  let navigate = useNavigate();

  const BoardDirector = () => {
    navigate("/board")
  }
  const People = () => {
    navigate("/management")
  }
  const Lartey = () => {
    navigate("/robertlartey")
  }
  const RobertAsmah = () => {
    navigate("/robertasmah")
  }
  const AlmaMensah = () => {
    navigate("/almamensah")
  }
  const BenBaidoo = () => {
    navigate("/benjaminbaidoo")
  }
  const JeremiahAddo = () => {
    navigate("/jeremiahaddotwum")
  }
  const Nana = () => {
    navigate("/nanayaa")
  }
  const StephenJomo = () => {
    navigate("/stephenjomo")
  }
  const Nylander = () => {
    navigate("/natashanylander")
  }
  const SylviaArcher = () => {
    navigate("/sylviaarcher")
  }

  const ReneNelson = () => {
    navigate("/renenelson")
  }

  const Emmanuel = () => {
    navigate("/emmanuel")
  }

  const Judith = () => {
    navigate("/judith")
  }

  const YvonneWiredu = () => {
    navigate("/yvonne")
  }
  return (

    <>
      <Navigation />

      <div className="relative">
        <div className="absolute inset-0 bg-black bg-opacity-50 flex">
          <h1 className="font-fjalla text-white text-2xl xs:mt-8 xs:ml-10 sm:text-3xl sm:mt-20 sm:ml-10  md:text-4xl md:mt-20 md:ml-10 lg:text-5xl lg:mt-24 lg:m-10 xl:text-6xl xl:mx-[270px]">
          </h1>
        </div>
        <img
          className="w-full h-auto xs:w-full xs:h-[200px] xs:object-cover sm:w-full sm:h-[300px] md:w-full md:h-[400px] md:object-cover lg:w-full lg:h-[500px] xl:w-full xl:"
          src={HeaderImage}
          alt="Ghana Gas GPP"
        />
      </div>

      <h1 className="font-fjalla text-gasblue text-2xl xs:mt-8 xs:ml-10 sm:text-3xl sm:mt-20 sm:ml-10 phone:hidden md:block  md:text-4xl md:mt-20 md:ml-10 lg:text-5xl lg:m-10 xl:text-5xl xl:mx-[270px] xl:mt-[100px]">
        Executive Management
      </h1>

      <div class="grid md:grid-cols-3 gap-4 phone: grid-cols-2" onClick={Judith}>
        <div class="col-span-1 flex items-center justify-end">
          <img src={JudithBlay} alt="CEO Image" className='scale-75' />
        </div>
        <div class="col-span-2 flex items-center">
          <div>
            <p class="text-black font-fjalla text-[24px] md:mx-20 phone:mx-10">Ms Judith Adjobah Blay</p>
            <p class="text-black font-fira text-[20px] md:mx-20 phone:mx-10">Chief Executive Officer</p>
            <p class="text-black font-fira md:text-[19px] phone:text-[15px] md:mx-20 phone:mx-10 text-justify leading-snug">
              Ms Judith Adjobah Blay has over two decades of distinguished experience in Ghana’s energy sector and beyond. She is widely recognised for her strategic leadership, policy development expertise, and commitment to sustainable business practices. Throughout her career, Ms Blay has successfully managed multi-million-dollar projects, strengthened regulatory compliance, and championed local content development. Her leadership has consistently driven operational excellence, fostered stakeholder engagement, and improved governance across several critical roles.

            </p>
            <p class="text-black font-fira md:text-[16px] md:mx-20 phone:text-[12px] phone:mx-10 hover:cursor-pointer">Read More</p>
          </div>
        </div>
      </div>

      <div class="grid md:grid-cols-3 gap-4 phone: grid-cols-2 mt-20 md:mt-15" onClick={Lartey}>
        <div class="col-span-1 flex items-center justify-end">
          <img src={RobertLartey} alt="CEO Image" className='scale-75' />
        </div>
        <div class="col-span-2 flex items-center">
          <div>
            <p class="text-black font-fjalla text-[24px] md:mx-20 phone:mx-10">Dr. Robert Lartey</p>
            <p class="text-black font-fira text-[20px] md:mx-20 phone:mx-10">Deputy Chief Executive Officer, Technical</p>
            <p class="text-black font-fira md:text-[19px] phone:text-[15px] md:mx-20 phone:mx-10 text-justify leading-snug">
              Ing. Lartey is a Chemical Engineer by profession. He started his career as Process Engineer at Tema Oil Refinery (TOR) Limited, Tema - rising to the position of Senior Process Engineer before he resigned to take up the role of Process Engineering Lead on the Western Corridor Gas Infrastructure Development Project (WCGIDP), implemented by the newly incorporated Ghana National Gas Limited Company (Ghana Gas).</p>
            <p class="text-black font-fira md:text-[16px] md:mx-20 phone:text-[12px] phone:mx-10 hover:cursor-pointer">Read More</p>
          </div>

        </div>
      </div>

      <div class="grid md:grid-cols-3 gap-4 phone: grid-cols-2 mt-20 md:mt-15" onClick={ReneNelson}>
        <div class="col-span-1 flex items-center justify-end">
          <img src={Rene} alt="CEO Image" className='scale-75' />
        </div>
        <div class="col-span-2 flex items-center">
          <div>
            <p class="text-black font-fjalla text-[24px] md:mx-20 phone:mx-10">Rene Stephen Nelson</p>
            <p class="text-black font-fira text-[20px] md:mx-20 phone:mx-10">Deputy Chief Executive Officer, Finance and Administration</p>
            <p class="text-black font-fira md:text-[19px] phone:text-[15px] md:mx-20 phone:mx-10 text-justify leading-snug">
              Rene is an accomplished accounting and finance professional with over 29 years valuable experience mostly at managerial level in a number of companies across various industry sectors. Rene has in-depth analytical and problem-solving skills and is proficient in treasury management, financial management and project finance.            </p>
            <p class="text-black font-fira md:text-[16px] md:mx-20 phone:text-[12px] phone:mx-10 hover:cursor-pointer">Read More</p>

          </div>

        </div>
      </div>



      <div class="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 xl:px-[12rem] xl:pt-[8rem]">


        <div className='flex flex-col items-center text-center hover:cursor-pointer' onClick={StephenJomo}>
          <img src={Jomo} className='md:scale-75 phone:scale-50' alt="Stephen Borteye Jomo" />
          <span className='font-fjalla text-[22px]'>Mr. Stephen Borteye Jomo</span>
          <span className='font-fira text-[17px]'>General Manager, Commercial Operations</span>
        </div>

        <div className='flex flex-col items-center text-center hover:cursor-pointer' onClick={SylviaArcher}>
          <img src={Sylvia} className='md:scale-75 phone:scale-50' alt="Stephen Borteye Jomo" />
          <span className='font-fjalla text-[22px]'>Mrs. Sylvia Assimeng Archer</span>
          <span className='font-fira text-[17px]'>General Manager, Legal</span>
        </div>



      </div>

      <div class="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 xl:px-[12rem] xl:pt-[8rem]">


        <div className='flex flex-col items-center text-center hover:cursor-pointer'>
          <img src={Charlotte} className='md:scale-75 phone:scale-50' alt="Stephen Borteye Jomo" />
          <span className='font-fjalla text-[22px]'>Ms. Charlotte Lily Baidoo</span>
          <span className='font-fira text-[17px]'>General Manager, Administration and General Services</span>
        </div>


        <div className='flex flex-col items-center text-center hover:cursor-pointer' >
          <img src={Sampson} className='md:scale-75 phone:scale-50' alt="Stephen Borteye Jomo" />
          <span className='font-fjalla text-[22px]'>Ing. Sampson Kekesi Doh</span>
          <span className='font-fira text-[17px]'>General Manager, Operations</span>
        </div>
      </div>

      <div class="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 xl:px-[12rem] xl:pt-[8rem]">


        <div className='flex flex-col items-center text-center hover:cursor-pointer' >
          <img src={Maxwell} className='md:scale-75 phone:scale-50' alt="Stephen Borteye Jomo" />
          <span className='font-fjalla text-[22px]'>Ing. Maxwell Kwame Kally</span>
          <span className='font-fira text-[17px]'>General Manager, Engineering and Maintenance</span>
        </div>


        <div className='flex flex-col items-center text-center hover:cursor-pointer' onClick={Emmanuel}>
          <img src={Moses} className='md:scale-75 phone:scale-50' alt="Stephen Borteye Jomo" />
          <span className='font-fjalla text-[22px]'>Dr. Emmanuel Kobina Moses</span>
          <span className='font-fira text-[17px]'>General Manager, Projects</span>
        </div>
      </div>

      <div class="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 xl:px-[12rem] xl:pt-[8rem]">


<div className='flex flex-col items-center text-center hover:cursor-pointer' >
  <img src={Issaka} className='md:scale-75 phone:scale-50' alt="Stephen Borteye Jomo" />
  <span className='font-fjalla text-[22px]'>Mr. Issaka Abdul-Jamil</span>
  <span className='font-fira text-[17px]'>General Manager, Supply Chain Management</span>
</div>


<div className='flex flex-col items-center text-center hover:cursor-pointer'onClick={YvonneWiredu}>
  <img src={Yvonne} className='md:scale-75 phone:scale-50' alt="Stephen Borteye Jomo" />
  <span className='font-fjalla text-[22px]'>Ms. Yvonne Ama Adiepena Wiredu-Akpabli</span>
  <span className='font-fira text-[17px]'>General Manager, Human Resource</span>
</div>
</div>




      <div class="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 xl:px-[12rem] xl:pt-[8rem]">

      </div>

      <br />

      <div className="relative hover:cursor-pointer" onClick={BoardDirector}>
        <div className="absolute inset-y-0 inset-x-1/2 left-0 bg-black bg-opacity-50 flex">
          <h1 className="font-fjalla text-white text-2xl xs:mt-8 xs:ml-10 sm:text-3xl sm:mt-20 sm:ml-10  md:text-4xl md:mt-20 md:ml-10 lg:text-5xl lg:mt-24 lg:m-10 xl:text-6xl xl:mt-30 xl:ml-30">
            Board Members
          </h1>
        </div>
        <img
          className="w-full h-auto xs:w-full xs:h-[200px] xs:object-cover sm:w-full sm:h-[300px] md:w-full md:h-[400px] md:object-cover lg:w-full lg:h-[400px] xl:w-full xl:"
          src={Board}
          alt="Ghana Gas GPP"
        />
      </div>


      <div className="relative hover:cursor-pointer" onClick={People}>
        <div className="absolute inset-y-0 inset-x-1/2 right-0 bg-black bg-opacity-50 flex">
          <h1 className="font-fjalla text-white text-2xl xs:mt-8 xs:ml-10 sm:text-3xl sm:mt-20 sm:ml-10  md:text-4xl md:mt-20 md:ml-10 lg:text-5xl lg:mt-24 lg:m-10 xl:text-6xl xl:mt-30 xl:ml-30">
            Management
          </h1>
        </div>
        <img
          className="w-full h-auto xs:w-full xs:h-[200px] xs:object-cover sm:w-full sm:h-[300px] md:w-full md:h-[400px] md:object-cover lg:w-full lg:h-[400px] xl:w-full xl:h-[]"
          src={HeaderImage}
          alt="Ghana Gas GPP"
        />
      </div>


      <Footer />
    </>
  )

}

export default Leadership;